/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import tabs from '../../../../constants/tabs';
import LocalizationConsumer from '../../../../l10n/localization-context';


const TabSwitcher = ({ onChange, activeTab }) =>
{
  const activeTabClass = classnames({
    '-wa-edit-controls__tab-switcher': true,
    '-wa-edit-controls__tab-switcher__website-active': activeTab === tabs.WEBSITE,
    '-wa-edit-controls__tab-switcher__sitepage-active': activeTab === tabs.PAGE,
    '-wa-edit-controls__tab-switcher__events-active': activeTab === tabs.EVENTS
  });

  return (
    <div className={activeTabClass}>
      <div className="-wa-edit-controls__website-switch" onClick={onChange(tabs.WEBSITE)} >
        <LocalizationConsumer id="insert-link-dialog.tab-switcher.website" />
      </div>
      <div className="-wa-edit-controls__sitepage-switch" onClick={onChange(tabs.PAGE)} >
        <LocalizationConsumer id="insert-link-dialog.tab-switcher.site-page" />
      </div>
      <div className="-wa-edit-controls__events-switch" onClick={onChange(tabs.EVENTS)} >
        <LocalizationConsumer id="insert-link-dialog.tab-switcher.event" />
      </div>
    </div>
  );
};

TabSwitcher.propTypes = {
  onChange: PropTypes.func.isRequired,
  activeTab: PropTypes.oneOf(Object.values(tabs)).isRequired
};

export default TabSwitcher;

